import React from "react";
import { Card } from "../../components/common/Card";
import QuickAccess from "../../assets/dashboard/external-link.svg";
import QuickExpert from "../../assets/dashboard/usertie.svg";
import QuickAnswer from "../../assets/dashboard/chat-bubble-question.svg";
import UserProfile from "../../assets/dashboard/userProfile.svg";
import CreateTooltip from "../../assets/dashboard/createTooltip.svg";
import LiveSession from "../../assets/dashboard/liveSession.svg";
import { ExternalLink } from "lucide-react";

import QuickSupport from "../../assets/dashboard/quickSupport.svg";
import { Video } from "lucide-react";
export interface QuickSupportCardProps {
  isExpertView?: boolean;
}

const QuickSupportCard: React.FC<QuickSupportCardProps> = ({
  isExpertView = false,
}) => {
  console.log(isExpertView, "isExpertView");
  return (
    <div>
      {/* Hero Section */}
      <div className="bg-[#F15D180A] rounded-[24px] p-4">
        <div className="rounded-xl p-8 mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            <div>
              <h2 className="text-[36px] nunito-medium text-[#404040] mb-4">
                Quick Support, Always.
              </h2>
              <p className="text-[#696969] text-[16px] nunito-regular mb-6 max-w-xl">
                {isExpertView
                  ? "Welcome to Supporty.io. As an expert on Supporty, you can showcase your skills, create valuable solutions, and monetize your knowledge seamlessly. With dedicated tools, you can build your professional portfolio, offer solutions, and engage with customers effectively."
                  : "Welcome to Supporty.io – your trusted partner for instant support and expert guidance. Get started effortlessly with quick links, intelligent answers, and expert help at your fingertips."}
              </p>
            </div>
            <img
              src={QuickSupport}
              alt="Support illustration"
              className="w-full md:w-1/3"
            />
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 px-10">
          {isExpertView ? (
            // Expert view cards
            <>
              <Card
                className="p-6 relative rounded-[24px] border-[1px] overflow-hidden bg-gradient-to-b from-white/24 to-transparent border-solid border-[rgba(255,255,255,0.8)]"
                style={{
                  boxShadow: `
                    0px 2px 4px 0px #0000000D, 
                    0px 5px 10px 0px #0000000D, 
                    0px 0px 10px 0px #0000000D, 
                    0px 22px 20px 0px #00000014, 
                    0px 8.8px 8.8px 0px #00000008, 
                    inset 2px 2px 2px 0px #0000001A
                  `,
                }}
              >
                <div className="flex gap-2 items-center relative">
                  <div className="">
                    <img src={UserProfile} className="h-[112px] w-[112px]" />
                  </div>
                  <div>
                    <h3 className="nunito-medium text-[24px] mb-1 text-[#404040]">
                      Update Profile
                    </h3>
                    <p className="text-[#696969] w-[179px] text-[14px] nunito-regular">
                      Update your profile and showcase your expertise with a
                      compelling portfolio.
                    </p>
                  </div>
                </div>
              </Card>

              <Card
                className="p-6 relative rounded-[24px] border-[1px] overflow-hidden bg-gradient-to-b from-white/24 to-transparent border-solid border-[rgba(255,255,255,0.8)]"
                style={{
                  boxShadow: `
                    0px 2px 4px 0px #0000000D, 
                    0px 5px 10px 0px #0000000D, 
                    0px 0px 10px 0px #0000000D, 
                    0px 22px 20px 0px #00000014, 
                    0px 8.8px 8.8px 0px #00000008, 
                    inset 2px 2px 2px 0px #0000001A
                  `,
                }}
              >
                <div className="flex gap-2 items-center">
                  <div className="">
                    <img src={CreateTooltip} className="h-[112px] w-[112px]" />
                  </div>
                  <div>
                    <h3 className="nunito-medium text-[24px] mb-1 text-[#404040]">
                      Create Tooltips
                    </h3>
                    <p className="text-[#696969] text-[14px] nunito-regular w-[179px]">
                      Design and sell tooltips that help customers solve
                      problems efficiently.
                    </p>
                  </div>
                </div>
              </Card>

              <Card
                className="p-6 relative rounded-[24px] border-[1px] overflow-hidden bg-gradient-to-b from-white/24 to-transparent border-solid border-[rgba(255,255,255,0.8)]"
                style={{
                  boxShadow: `
                    0px 2px 4px 0px #0000000D, 
                    0px 5px 10px 0px #0000000D, 
                    0px 0px 10px 0px #0000000D, 
                    0px 22px 20px 0px #00000014, 
                    0px 8.8px 8.8px 0px #00000008, 
                    inset 2px 2px 2px 0px #0000001A
                  `,
                }}
              >
                <div className="flex gap-2 items-center">
                  <Video className=" w-[112px] h-[112px] text-[#F15D18] stroke-[0.6px]" />

                  <div>
                    <h3 className="nunito-medium text-[24px] mb-1 text-[#404040]">
                      Live Sessions
                    </h3>
                    <p className="text-[#696969] text-[14px] nunito-regular w-[179px]">
                      Interact real-time with customers to offer solutions &
                      earn from your expertise.
                    </p>
                  </div>
                </div>
              </Card>
            </>
          ) : (
            // Default user view cards
            <>
              <Card
                className="p-6 relative rounded-[24px] border-[1px] overflow-hidden bg-gradient-to-b from-white/24 to-transparent border-solid border-[rgba(255,255,255,0.8)]"
                style={{
                  boxShadow: `
                    0px 2px 4px 0px #0000000D, 
                    0px 5px 10px 0px #0000000D, 
                    0px 0px 10px 0px #0000000D, 
                    0px 22px 20px 0px #00000014, 
                    0px 8.8px 8.8px 0px #00000008, 
                    inset 2px 2px 2px 0px #0000001A
                  `,
                }}
              >
                <div className="flex gap-4 items-center relative">
                  <div className="">
                    <img src={QuickAccess} className="h-[112px] w-[112px]" />
                  </div>
                  <div>
                    <h3 className="nunito-medium text-[#404040] text-[24px] mb-1">
                      Quick Access
                    </h3>
                    <p className="text-[#696969] text-[14px] nunito-regular w-[179px]">
                      Find all the help you need with curated tooltips,
                      tutorials, & links to support chats or the help center.
                    </p>
                  </div>
                </div>
              </Card>

              <Card
                className="p-6 relative rounded-[24px] border-[1px] overflow-hidden bg-gradient-to-b from-white/24 to-transparent border-solid border-[rgba(255,255,255,0.8)]"
                style={{
                  boxShadow: `
                    0px 2px 4px 0px #0000000D, 
                    0px 5px 10px 0px #0000000D, 
                    0px 0px 10px 0px #0000000D, 
                    0px 22px 20px 0px #00000014, 
                    0px 8.8px 8.8px 0px #00000008, 
                    inset 2px 2px 2px 0px #0000001A
                  `,
                }}
              >
                <div className="flex gap-4 items-center rounded-[24px]">
                  <div className="">
                    <img src={QuickAnswer} className="h-[112px] w-[112px]" />
                  </div>
                  <div>
                    <h3 className="nunito-medium text-[24px] text-[#404040] mb-1">
                      Quick Answers
                    </h3>
                    <p className="text-[#696969] text-[14px] nunito-regular w-[179px]">
                      Get instant, intelligent guidance from our chatbot via
                      text, audio, or video conversation.
                    </p>
                  </div>
                </div>
              </Card>

              <Card
                className="p-6 relative rounded-[24px] border-[1px] overflow-hidden bg-gradient-to-b from-white/24 to-transparent border-solid border-[rgba(255,255,255,0.8)]"
                style={{
                  boxShadow: `
                    0px 2px 4px 0px #0000000D, 
                    0px 5px 10px 0px #0000000D, 
                    0px 0px 10px 0px #0000000D, 
                    0px 22px 20px 0px #00000014, 
                    0px 8.8px 8.8px 0px #00000008, 
                    inset 2px 2px 2px 0px #0000001A
                  `,
                }}
              >
                <div className="flex gap-4 items-center">
                  <div className="">
                    <img src={QuickExpert} className="h-[112px] w-[112px]" />
                  </div>
                  <div>
                    <h3 className="nunito-medium text-[#404040] text-[24px] mb-1">
                      Quick Experts
                    </h3>
                    <p className="text-[#696969] text-[14px] nunito-regular w-[179px]">
                      Connect with subject matter experts through chat or video
                      for personalised solutions to your questions.
                    </p>
                  </div>
                </div>
              </Card>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuickSupportCard;
